import React, { useState } from 'react';
import { GET_MANY, UPDATE } from 'ra-core';
import { useDataProvider, downloadCSV, Button as AdminButton } from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import PublishIcon from '@mui/icons-material/Publish';
import { DropzoneDialog } from 'react-mui-dropzone';
import ResultDialog from '../../../Utilities/ResultDialog';
import { unparse as convertToCSV, parse } from 'papaparse/papaparse.min';
import { Anomalie } from '../../objects';

function UploadFileMassiveChiuso() {

    const [open, setOpen ] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);
    const [resultDialogTitle, setResultDialogTitle] = useState('');

    const dataProvider = useDataProvider();

    const handleClose = () => {
        setOpen(false);
    }

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogRows([]);
        setResultDialogHeaders([]);
        setResultLoading(false);
    }

    const handleSave = async (files) => {
        var startTime = new Date();
        setOpen(false);
        setResultDialogOpen(true);
        setResultLoading(true);

        const expectedFormat = "serial_number_tim,anomalia,num_consegna,note";
        const separatorsPerRow = expectedFormat.split(",").length - 1;

        //Saving files to state for further use and closing Modal.
        var text = await (await (new Response(files[0])).text()).toString().replaceAll('"', '');
        if (text.indexOf(expectedFormat) === 0) {
            let validRow = true;
            let lineBreak = text.indexOf("\r\n") > -1 ? "\r\n" : text.indexOf("\r") > -1 ? "\r" : "\n";
            let rows = text.split(lineBreak);
            let tempText = "";
            rows.forEach(row => {
                if (row !== "") {
                    let t = 0;
                    let cleanRowText = row.replace(/,/g, match => ++t > 3 ? ' ' : match);
                    tempText = tempText + cleanRowText + lineBreak;

                    //make sure that in each rows we have the expected number of columns
                    if (cleanRowText.split(",").length - 1 !== separatorsPerRow) {
                        validRow = false;
                    }
                }
            });
            text = tempText;

            if (!validRow) {
                setResultDialogOpen(true);
                setResultDialogHeaders(["File Status"]);
                setResultDialogRows([["Il file non è nel formato previsto. " + expectedFormat]]);
                setResultDialogTitle('Risultati');
                setResultLoading(false);
            }
            else {
                var output = await parse(text.toString(), {
                    delimiter: ',',
                    header: true,
                    skipEmptyLines: true
                }).data;

                await validateRows(output);
                var resultArray = [];

                for (let i = 0; i < output.length; i++) {
                    let row = output[i];
                    let risultato_icon = <DoneIcon />;

                    if (row.validationResult === '✓') {
                        let result = await updateDeviceToChiuso(row);
                        if (result?.data?.message !== 'Updated') {
                            row.validationResult = result;
                            risultato_icon = <ErrorIcon />;
                        }
                        else {
                            row.validationResult = '';
                            row.device_status = result.data.doc.status.descrizione;
                            row.device_anomalia = result.data.doc.anomalia ? result.data.doc.anomalia.descrizione : '';
                        }
                    }
                    else {
                        risultato_icon = <ErrorIcon />;
                    }

                    resultArray.push([row.serial_number_tim, row.anomalia, row.num_consegna, row.device_status, row.device_anomalia, risultato_icon, row.validationResult])
                }
                setResultDialogOpen(true);
                setResultDialogHeaders(["Apparato", "Anomalia", "num_consegna", "Stato attuale", "Anomalia attuale", "Risultato", "Dettaglio"]);
                setResultDialogRows(resultArray);
                setResultDialogTitle('Risultati');
                setResultLoading(false);
            }
        }
        else {
            setResultDialogOpen(true);
            setResultDialogHeaders(["File Status"]);
            setResultDialogRows([["Il file non è nel formato previsto. " + expectedFormat]]);
            setResultDialogTitle('Risultati');
            setResultLoading(false);
        }

        var endTime = new Date();
        console.log(timeElpased(startTime, endTime));
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const exportToCSV = () => {
        const resultForExport = this.state.resultDialogRows.map(row => {
            const { ...resultForExport } = {};
            resultForExport.Apparato = row[0];
            resultForExport.Anomalia = row[1];
            resultForExport.num_consegna = row[2];
            resultForExport["Stato attuale"] = row[3];
            resultForExport["Anomalia attuale"] = row[4];
            resultForExport.Risultato = row[5].type.type.render.displayName === 'DoneIcon' ? 'OK' : 'KO';
            resultForExport.Dettaglio = row[6];
            return resultForExport;
        })
        const csv = convertToCSV({
            data: resultForExport,
            fields: this.state.resultDialogHeaders
        });
        downloadCSV(csv, 'Risultati');
    }

    //performs validations for each row and returns the result so the
    //user know which rows will be updated in the DB and which ones will not (including the reason)
    const validateRows = async (output) => {
        var serialNums = getArrayByProperty(output, 'serial_number_tim');
        var chunkedOutput = chunkOuput(serialNums, 10);

        let dbDevices = [];

        for (let index = 0; index < chunkedOutput.length; index++) {
            var tempDevices = await dataProvider(GET_MANY, 'devices', {
                "filter": {
                    "status.codice": { $exists: true }, //this is just to be sure that we search for all statuses (overrriding mandatory filters on server side)
                    "serial_number_tim": { $in: chunkedOutput[index] }
                }
            })
                .then(
                    response => {
                        if (response.total > 0)
                            return response.data;
                        else
                            return undefined;
                    })
                .catch(error => {
                    console.log(error);
                });

            if (tempDevices) {
                tempDevices.forEach(device => {
                    dbDevices.push(device);
                })
            }
        };

        output.forEach(row => {
            let device = dbDevices.find(dev => row.serial_number_tim === dev.serial_number_tim);
            //	Caso1. Check sul seraile: il seraile esiste nell’area di appartenenza  SN NON PRESENTE
            if (device) {
                row.device_status = device.status.descrizione;
                row.device_anomalia = device.anomalia ? device.anomalia.descrizione : "";
                row.device_num_consegna_orig = device.num_consegna_orig;
                row.device_num_consegna = device.num_consegna;
                //	Caso2: Check sullo stato che deve essere Attribuito o Da esaminare con anomalia “SN NON ANAGRAFATO” STATO NON CONGRUENTE
                if ((!['1','6'].includes(device.status.codice) && device.status.codice !== '0') || (device.status.codice === '0' && device.anomalia.codice !== '0')) {
                    row.validationResult = "STATO NON CONGRUENTE";
                }
                //anomalia is mandatory
                else if (!row.anomalia) {
                    row.validationResult = "ANOMALIA NON CONGRUENTE"
                }
                //	Caso3: Check su Anomalia, a meno di maiuscolo/minuscolo
                else if (device.status.codice === '1' && !['FURTO', 'SMARRITO', 'FITTIZIO', 'RESO', 'AMMANCO INVENTARIO', 'ERRORE CONSEGNA'].includes(row.anomalia.toUpperCase())) {
                    row.validationResult = "ANOMALIA NON CONGRUENTE";
                }
                //	Caso3: Check su Anomalia, a meno di maiuscolo/minuscolo
                else if (device.status.codice === '0' && !['GIA SCARICATA MOS', 'MATERIALE MOS'].includes(row.anomalia.toUpperCase())) {
                    row.validationResult = "ANOMALIA NON CONGRUENTE";
                }
                //	Caso4: Il campo num_consegna deve essere avvalorato nel caso di anomalia FURTO, SMARRITO
                else if (['FURTO', 'SMARRITO'].includes(row.anomalia.toUpperCase()) && !row.num_consegna) {
                    row.validationResult = "NUM_CONSEGNA NON AVVALORATO";
                }
                //	Caso5: il concatenamento delle Note non deve superare 999 caratteri
                else if (row.note && (device.note && (row.note.length + device.note.length) > 999) || (row.note && row.note.length > 999)) {
                    row.validationResult = "CAMPO NOTE ECCEDENTE";
                }
                //	TO_CR_194
                else if (row.num_consegna && (isNaN(row.num_consegna) || row.num_consegna.length > 10 || row.num_consegna > 9999999999)) {
                    row.validationResult = "Il campo num_consegna deve essere numerico e lungo al massimo 10 caratteri";
                }
                else {
                    row.validationResult = "✓";
                    row.device = device;

                    //remove special chars from note
                    if (row.note) {
                        row.note = row.note.replace(/[^a-zA-Z0-9 ]/g, '');
                        row.note = device.note ? device.note + " " + row.note : row.note;
                    }
                }
            }
            else {
                row.validationResult = "SN NON PRESENTE";
            }
        })
    }

    const updateDeviceToChiuso = async (row) => {
        let updateProps = {
            id: row.device.id,
            data: {
                status: { codice: '9', descrizione: 'Chiuso' },
                anomalia: { codice: Anomalie.find(a => a.name === row.anomalia.toUpperCase())?.id },
                closed_at: new Date(),
                closed_by: localStorage.getItem('username')
            }
        };

        if (row.num_consegna && row.num_consegna !== '') {
            //TO_CR_241
            if (!row.device_num_consegna_orig) {
                updateProps.data.num_consegna_orig = row.device_num_consegna;
            }
            updateProps.data.num_consegna = row.num_consegna;
        }
        if (row.note && row.note !== '') updateProps.data.note = row.note;

        let res = await dataProvider(UPDATE, 'devices', updateProps);
        return res;
    }

    const timeElpased = (starTime, endTime) => {
        var timeDiff = endTime - starTime;
        timeDiff /= 1000;
        var seconds = Math.round(timeDiff);
        return seconds;
    }

    const chunkOuput = (output, chunk_size) => {
        var tempOutput = output.slice();
        var results = [];
        while (tempOutput.length) {
            results.push(tempOutput.splice(0, chunk_size));
        }
        return results;
    }

    const getArrayByProperty = (array, property) => {
        var propertyArray = []
        array.forEach(item => {
            propertyArray.push(item[property])
        });
        return propertyArray;
    }

    return (
        <div>
            <AdminButton label='Upload Chiusura Forzata' onClick={handleOpen.bind(this)} >
                <PublishIcon />
            </AdminButton>
            <DropzoneDialog
                open={open}
                onSave={handleSave.bind(this)}
                acceptedFiles={['application/vnd.ms-excel', 'text/csv']}
                dropzoneText={'Trascina e rilascia qui un file CSV nel formato serial_number_tim,anomalia,num_consegna,note'}
                filesLimit={1}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={handleClose.bind(this)}
            />
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title={resultDialogTitle}
                onClose={handleResultClose} >
                {!resultLoading && <AdminButton label='tim.uploadfile.export' onClick={exportToCSV} color="primary"></AdminButton>}
                {!resultLoading && <AdminButton label='Conferma' onClick={handleResultClose.bind(this)} color="primary"></AdminButton>}
            </ResultDialog>
        </div>
    );
}

export default UploadFileMassiveChiuso;